import React, { useState } from "react";

import {
  Campaign,
} from "@dndModels";
import { ArchivableCampaignObjectType } from "@dndModels/Types";

import API from "@utilities/smart_api";
import CheckBox from "@components/input/CheckBox";

const api = API.getInstance();

interface Props {
  campaign: Campaign;
  data_type: ArchivableCampaignObjectType;
  value: boolean;
  disabled?: boolean;
  onChange: (view_archives: boolean) => void;
}

export default function ViewArchivesCheckBox({
  campaign,
  data_type,
  value,
  disabled = false,
  onChange
}: Props) {
  const [loading, setLoading] = useState(false);

  return (
    <CheckBox
      name={ loading ? "Loading" : "View Archives" }
      value={value}
      disabled={ disabled || loading || !api.online }
      onChange={ async () => {
        setLoading(true);
        if (!value) {
          await api.loadArchivedCampaignObjects({ campaign, data_type });
        } else if (campaign.get_campaign_objects(data_type).length === 0) {
          // Things may have been unarchived while viewing archives,
          // and they only get added to the active list if it was already loaded.
          const objects = await api.getCampaignObjects({ data_type, campaign });
          campaign.set_campaign_objects(data_type, objects);
        }
        setLoading(false);
        onChange(!value);
      }}
    />
  );
}
